import * as Yup from 'yup';
import dayjs from 'dayjs';

export const defaultInfo = {
  page: 1,
  phone: '',
  user_code: '',
  code: '',
  status: '',
  start_at: dayjs().format('YYYY-MM-DD'),
  end_at: dayjs().format('YYYY-MM-DD'),
  time_range: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
};

/**
 * 购物袋item
 */
export interface BagItem {
  /**
   * 品牌名称
   */
  brand_name: string;
  /**
   * 数量
   */
  num: string;
}

/**
 * 免提购物详情
 */
export interface ShoppingDetailInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 投诉处理赔偿
   * - 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  handsfree_items: BagItem[];
}

/**
 * 免提购物详情表单默认值
 */
export const defaultDetailInfo: ShoppingDetailInfo = {
  remark: '',
  handsfree_items: [{ brand_name: '', num: '1' }],
};

export enum ORDER_STATUS {
  /**
   * 已取消
   */
  CANCEL,

  /**
   * 新订单
   */
  NEW_ORDER,

  /**
   * 待取货
   */
  WAIT_GOODS,

  /**
   * 已完成
   */
  COMPLTED
}

export const orderStatus = [
  { label: '已取消', value: ORDER_STATUS.CANCEL },
  { label: '新订单', value: ORDER_STATUS.NEW_ORDER },
  { label: '待取货', value: ORDER_STATUS.WAIT_GOODS },
  { label: '已完成', value: ORDER_STATUS.COMPLTED },
]

export const registerModalSchema = Yup.object().shape(
  {
    shopping_bag: Yup.array().of(
      Yup.object({
        brand_name: Yup.string().ensure().required('请选择品牌'),
        num: Yup.string().ensure().required('请输入购物袋数量').matches(/^[1-9]\d*$/, '请输入正确的数量'),
      })
    ).min(1, '请至少增加一个购物袋').required('请至少增加一个购物袋')
  }
)

/**
 * 免提购物详情表单校验
 */
export const shoppingDetailSchema = Yup.object().shape(
  {
    handsfree_items: Yup.array().of(
      Yup.object({
        brand_name: Yup.string().ensure().required('请选择品牌'),
        num: Yup.string().ensure().required('请输入购物袋数量').matches(/^[1-9]\d*$/, '请输入正确的数量'),
      })
    )
  }
)
